import { useState } from 'react';
import { Box, Flex, Fade } from "@chakra-ui/react";
import InputTextAreaExpandable from '../../../forms/TextareaField/components/InputTextAreaExpandable';
import { PiFrameCornersThin } from "react-icons/pi";
import { ButtonWithIcon } from "../../dsr-record-content/ButtonWithIcon";
import WarningTextMessage from '../../../global/components/helper-components/components/WarningTextMessage';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';


export default function EmbedTileInput({ 
  onChangeHandler, 
  inputValue,
  handleClickSaveCode, 
  isInvalidInput, 
  isUnverifiedCode
}) {

  const [showInput, setShowInput] = useState(false)


  return (
    <Box position="relative" width='100%' minH='8em'>
        <Box display={showInput ? "block" : "none"}>
      <Fade in={showInput} >
        
        <Box mb='1em' >
          <Flex justify='space-between' align='center'>
          <Box fontSize='0.875em' color='brandDark.500' fontWeight='600'>Embed code</Box>

          </Flex>
     
          <Box fontSize='0.7em' color='gray.500'>We currently support <i>iframe</i>, <i>script</i>, or <i>iFramely</i> code snippets</Box>
        </Box>
        <InputTextAreaExpandable
          name="embedded-code"
          onChangeHandler={onChangeHandler}
          inputValue={inputValue}
          isInvalidInput={isInvalidInput}
          border='1px solid'
          borderColor='gray.200'
          color='brandDark.500'
        />
        <Box mt='0.5em'>
        <WarningTextMessage 
        textAlign='center'
        errorLogic={isUnverifiedCode} 
        message={`Please ensure it starts with <script> or <iframe>`} />
        </Box>
      </Fade>
      </Box>
      {/* {showInput === false && */}
        <Box display={showInput ? "none" : "block"}>
        <Fade in={!showInput} >
          <Flex w='100%' justify='center' align='center' mb='1em' pt='2em' >
            <Box as={PiFrameCornersThin} boxSize="5em" color="gray.500" />
          </Flex>
          <Box
            alignSelf="stretch"
            color='gray.500'
            textAlign='center'
            fontWeight='400'
            lineHeight='1.5em'
            fontSize='0.8em'
            py='0.5em'
          >
            <Box>Integrate with your own tools using</Box>
            <Box>iFrame or Script code</Box>
          </Box>
          </Fade>
          </Box>
      {/* } */}
      <Flex w='100%' justify='center' align='center' my='1em' >
        <Box display="flex" width="100%" justifyContent="center">

{showInput ?
<Flex justify='space-between' align='center' w='100%'>

<LaunchdeckButton bg='gray.500' color='white' px='2em' fontSize='0.8em' w={["100%", "auto"]} onClick={() => setShowInput(!showInput)} label='Cancel' />


<LaunchdeckButton bg='brand.500' color='white' px='2em' fontSize='0.8em'  w={["100%", "auto"]} onClick={() => handleClickSaveCode()} label='Save' />

</Flex>

:
<ButtonWithIcon
// icon={MdEmergencyRecording} 
label={showInput ? 'Save Code' :'Embed Code'}
// className={'overview-button'}
onClick={() => showInput ? handleClickSaveCode() : setShowInput(!showInput)}
// ref={recordButtonRef}
// disabled={buttonText === loomSdkStates.recordingNotSupported}
/>
}
         

        </Box>
      </Flex>
    </Box>

    // 
  )

}
